// @flow
import React from 'react';
import TertiaryButton from '../../common/components/TertiaryButton';
import useInviteCoachesFormManager from './hooks/useInviteCoachesFormManager';
import InviteCoachesModal from './InviteCoachesModal';

type Props = {
    buttonText: string,
    refreshList: () => {}
};

const ERROR_TEXT = 'Invalid email';

export default function InviteCoach({ buttonText, refreshList }: Props) {
    const {
        isModalVisible,
        setIsModalVisible,
        emails,
        setEmails,
        emailsValidated,
        emailsErrorMessage,
        message,
        setMessage,
        showValidationErrors,
        isInProgress,
        inviteCoaches,
        inviteFormSuccessfulOrNotSubmitted
    } = useInviteCoachesFormManager(refreshList);

    const hasEmailsError = showValidationErrors && !emailsValidated;

    const emailsErrorText = inviteFormSuccessfulOrNotSubmitted ? emailsErrorMessage : ERROR_TEXT;

    return (
        <>
            <TertiaryButton onClick={() => setIsModalVisible(true)}>{buttonText}</TertiaryButton>
            <InviteCoachesModal
                isModalVisible={isModalVisible}
                inviteCoaches={inviteCoaches}
                handleClose={() => setIsModalVisible(false)}
                emails={emails}
                setEmails={setEmails}
                hasEmailsError={hasEmailsError}
                emailsErrorText={emailsErrorText}
                message={message}
                setMessage={setMessage}
                isInProgress={isInProgress}
            />
        </>
    );
}

InviteCoach.defaultProps = {};
